import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combina clases de Tailwind resolviendo conflictos.
 *
 * El problema que resuelve: en Tailwind, si un elemento termina con
 * `class="px-4 px-8"`, cuál gana depende del orden en el CSS generado, no del
 * orden en que las escribiste. Eso hace imposible sobrescribir estilos desde
 * fuera de un componente de forma confiable.
 *
 * `cn` lo arregla: detecta que `px-4` y `px-8` son la misma propiedad y deja
 * solo la última. Así un componente puede aceptar `className` y el que lo usa
 * puede sobrescribir su estilo con la certeza de que su clase gana.
 *
 * @example
 * cn('px-4 text-sm', 'px-8')              // → 'text-sm px-8'
 * cn('rounded', isActive && 'bg-primary') // → ignora los valores falsos
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
